import { ELocalStorageKeys } from "@/app/types/localStorage";
import { getItemSessionStorage } from "@/lib/utils";

export type ProviderRegistrationFlowHint =
  | "LEGACY"
  | "SELF_SERVICE"
  | "UNKNOWN";

// JWT claims are only a routing hint, never authorization.
export const providerRegistrationFlowHintFromToken = (
  token: string,
): ProviderRegistrationFlowHint => {
  const parts = token.split(".");
  if (parts.length !== 3 || !parts[1]) return "UNKNOWN";

  try {
    const payload: unknown = JSON.parse(
      atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")),
    );

    if (!payload || typeof payload !== "object" || !("provider" in payload)) {
      return "UNKNOWN";
    }

    const provider = payload.provider;
    if (!provider || typeof provider !== "object") return "UNKNOWN";

    if (!("registrationLegalEvidence" in provider) ||
        provider.registrationLegalEvidence == null) {
      return "LEGACY";
    }

    const evidence = provider.registrationLegalEvidence;
    if (typeof evidence !== "object") return "UNKNOWN";

    if (!("registrationFlowVersion" in evidence) ||
        evidence.registrationFlowVersion == null) {
      return "LEGACY";
    }

    const version = evidence.registrationFlowVersion;
    return typeof version === "number" &&
      Number.isInteger(version) &&
      version >= 1
        ? "SELF_SERVICE"
        : "UNKNOWN";
  } catch {
    return "UNKNOWN";
  }
};

export const getProviderRegistrationFlowHint =
  (): ProviderRegistrationFlowHint => {
    const token = getItemSessionStorage(ELocalStorageKeys.TOKEN);
    return token
      ? providerRegistrationFlowHintFromToken(token)
      : "UNKNOWN";
  };
